export const ProgressBar = ({
  height = "7px",
  width = "100%",
  progress = 0,
  progressColor = "#7647ee",
}) => {
  return (
    <span
      style={{
        height: height,
        width: width,
        minWidth: width,
        background: "rgba(202, 198, 220, 1)",
        display: "block",
        borderRadius: "10px",
        position: "relative",
      }}
    >
      <span
        style={{
          height: "100%",
          width: progress <= 100 ? `${progress}%` : "100%",
          background: progressColor,
          display: "block",
          borderRadius: "10px",
        }}
      ></span>
    </span>
  );
};
